export const FOCUS_VISIBLE_OUTLINE = [
    "focus-visible:!outline-2",
    "focus-visible:!outline-dashed",
    "focus-visible:!outline-general-yellow-primary",
    "dark:focus-visible:!outline-general-yellow-primary-darkmode",
];
//# sourceMappingURL=css-helpers.js.map